import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LongpressDirective, VibrateDirective } from '@aston/foundation';

import { MenuComponent } from '../../../shared-module/components/menu/menu.component';
import { UserNotificationsStore } from '../../../notifications-module/stores';

@Component({
	selector: '[layout-menu-mobile]',
	template: `
	<ul #menulinks class="menu-links">
		<li>
			<a	class="user-select-none"
				data-cy="MenuParent"
				data-testid="MenuParent.HomePage"
				[routerLink]="routes.mobileHomePage"
				routerLinkActive="active"
				vibrate
			>
				<span>{{ 'PageTitles.Welcome' | translate }}</span>
				<i class="menu-icon fas fa-house"></i>
			</a>
		</li>
		<li>
			<a 	class="user-select-none"
				data-cy="MenuParent"
				data-testid="MenuParent.SuperDebtors"
				[routerLink]="routes.mobileSuperDebtorsList"
				routerLinkActive="active"
				vibrate
			>
				<span>{{ 'Menu.SuperDebtors' | translate }}</span>
				<i class="menu-icon fas fa-address-card"></i>
			</a>
		</li>
		<li>
			<a	class="user-select-none"
				data-cy="MenuParent"
				data-testid="MenuParent.Notifications"
				[routerLink]="routes.mobileNotificationsList"
				routerLinkActive="active"
				[longpress]="notifications.markAllAsRead"
				vibrate
			>
				<span>{{ 'TopBar.Tooltip.Notifications' | translate }}</span>
				<span class="btn-badged">
					@if (notifications.unreadCount(); as unread) {
						<span class="badge badge-pill badge-info">{{(unread <= 9) ? unread : '9+' }}</span>
					}
					<i class="menu-icon fas fa-bell"></i>
				</span>
			</a>
		</li>
	</ul>
	`,
	styles: `
		.badge-pill {
			transform: translate(-68%, -26%) !important;
			padding: 5px 9px !important;
			font-size: .7rem !important;
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, RouterLink, RouterLinkActive, VibrateDirective, LongpressDirective]
})
export class MenuMobileComponent extends MenuComponent {
	notifications = inject(UserNotificationsStore)
}
